//Library Imports
import React from 'react'

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import FlightLandOutlined from '@material-ui/icons/FlightLandOutlined'
import BackupOutlined from '@material-ui/icons/BackupOutlined'

import PageShell from '../../PageShell'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import InfoArea from 'components/InfoArea/InfoArea.jsx'

const SecurityContentNoStyle = ({ classes }) => (
    <div className={classes.section}>
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <h2 className={classes.title}>Security Features</h2>
                <h5 className={classes.description}>
          Its more than being HIPAA Compliant. While important, it is just not
          enough in today's day and age. Its about having a desire to do even
          more. Below is all about the complex security technologies we use to
          keep the data of yourself and your patients safe. If you have
          questions on specifics, contact us and we can help you.
                </h5>
            </GridItem>
        </GridContainer>
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Layered Security"
                        description="DDOS Protection (Distributed Denial Of Service), WAF(Web Application Firewalls), 2FA(2 Factor Authentication), MAC(Mandatory Access Control) are just a small subset of the technologies we employ to keep data safe from attackers and keep our service running constantly."
                        icon={VerifiedUser}
                        iconColor="success"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Encryption at Rest and In Flight"
                        description="We use the latest versions of TLS (Transport Layer Security) and a combination of other encryption algorithms (when data is being stored) to ensure that data is safe from prying eyes."
                        icon={FlightLandOutlined}
                        iconColor="success"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Point In Time & Disaster Recovery"
                        description="We operate in the cloud. This allows us to securely backup data across data centers automatically. Not only that, but in the event of a disaster we can failover our service to an entirely different data center automatically. That means there should never be an interruption getting in the way of you and your patients data. "
                        icon={BackupOutlined}
                        iconColor="success"
                        vertical
                    />
                </GridItem>
            </GridContainer>
        </div>
    </div>
)

const SecurityContentStyled = withStyles(productStyle)(SecurityContentNoStyle)

const Security = () => (
    <PageShell
        title="Security Inside"
        blurb="A top consideration with everything we do."
        img={require('assets/img/security-bg.jpg')}
        components={[<SecurityContentStyled key={0} />]}
    />
)

export default Security



// WEBPACK FOOTER //
// ./src/views/Features/Security/Security.jsx